import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import {
    avatar11,
    companyIcon,
} from '../../assets/images'
import { IconPrinter } from '@tabler/icons-react'
import { Link } from 'react-router-dom'

export default function Payslip() {
    return (
        <>
            <Breadcrumb title="Payslip" path="Payroll / Payslip" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='pb-30 mb-30 border-b border-border flex items-center justify-between gap-15 flex-wrap'>
                    <div className='flex gap-20'>
                        <img src={companyIcon} alt='company icon' width="70" height="70" className='company-logo w-[70px] h-[70px] object-contain' />
                        <div>
                            <p className='text-[16px]/[19.2px] font-medium mb-10'>
                                Lucid Infoweb LLC.
                            </p>
                            <p className='text-text-secondary'>
                                8117 Roosevelt St. <br />
                                New Rochelle, NY 10801
                            </p>
                        </div>
                    </div>
                    <div>
                        <p className='text-[24px]/[28.8px] font-medium mb-10'>
                            Invoice #1069
                        </p>
                        <p className='text-text-secondary'>
                            Salary Month: Jun, 2021
                        </p>
                    </div>
                </div>
                <div className='flex items-center gap-15 pb-20'>
                    <img src={avatar11} width="70" height="70" alt='user' className='w-[70px] h-[70px] object-cover rounded-full' />
                    <div>
                        <p className='text-[16px]/[19.2px] font-medium mb-10'>
                            Francisco Vasquez
                        </p>
                        <p>
                            Web Designer
                        </p>
                        <p>
                            Employee ID: LA-0258
                        </p>
                    </div>
                </div>
                <div className='grid lg:grid-cols-2 grid-cols-1 gap-30 mb-30'>
                    <div className='overflow-auto'>
                        <table className='w-full min-w-[374px]'>
                            <thead>
                                <tr>
                                    <th align='left' className='bg-bg-light-100 p-3'>
                                        #
                                    </th>
                                    <th align='left' className='bg-bg-light-100 p-3'>
                                        EARNINGS
                                    </th>
                                    <th align='left' className='bg-bg-light-100 p-3'>
                                        TOTAL
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        1
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Basic Salary
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $1,500
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        2
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        House Rent Allowance (H.R.A.)
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $50
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        3
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Bonus
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $150
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        4
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Conveyance
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $80
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        5
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Other Allowance
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $80
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        <b>
                                            -
                                        </b>
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        <b>
                                            Basic Salary
                                        </b>
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        <b>
                                            $1860
                                        </b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='overflow-auto'>
                        <table className='w-full min-w-[374px]'>
                            <thead>
                                <tr>
                                    <th align='left' className='bg-bg-light-100 p-3'>
                                        #
                                    </th>
                                    <th align='left' className='bg-bg-light-100 p-3'>
                                        DEDUCTIONS
                                    </th>
                                    <th align='left' className='bg-bg-light-100 p-3'>
                                        TOTAL
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        1
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Tax Deducted at Source (T.D.S.)
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $10
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        2
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        ESIC
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $0
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        3
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Provident Fund
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $150
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        4
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        C/Bank Loan
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $120
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        5
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Other Deductions
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        $8
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        <b>
                                            -
                                        </b>
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        <b>
                                            Basic Salary
                                        </b>
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        <b>
                                            $288
                                        </b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='grid lg:grid-cols-2 grid-cols-1 gap-30 mb-30'>
                    <div>
                        <p className='text-[20px]/[24px] font-medium mb-10'>
                            Note
                        </p>
                        <p>
                            Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya handango imeem plugg dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra.
                        </p>
                    </div>
                    <div className='lg:text-right'>
                        <p>
                            <b>
                                Total Earnings : &nbsp;
                            </b>
                            <span>
                                $1,860.00
                            </span>
                        </p>
                        <p>
                            <b>
                                Total Deductions : &nbsp;
                            </b>
                            <span>
                                $288.00
                            </span>
                        </p>
                        <p className='text-[20px]/[24px] font-medium mt-5'>
                            <b>
                                Net Salary : &nbsp;
                            </b>
                            <b>
                                $1572.00
                            </b>
                        </p>
                    </div>
                </div>
                <div className='flex gap-10 justify-end'>
                    <Link to="#" className='btn btn-outline-secondary'>
                        <IconPrinter className='w-[20px] h-[20px] text-text-primary' />
                    </Link>
                    <button className='btn btn-primary'>
                        Submit
                    </button>
                </div>
            </div>
        </>
    )
}
